import { FunctionComponent } from 'react';
import { Field, FieldConfig } from 'formik';
import { TextField, TextFieldProps } from '@mui/material';

export type FormikTextFieldProps = FieldConfig & {
    textFieldProps: TextFieldProps;
};
export const FormikTextField: FunctionComponent<
    React.PropsWithChildren<FormikTextFieldProps>
> = ({ textFieldProps, name }) => (
    <Field name={name}>
        {({ field, form: { errors } }) => (
            <TextField
                {...field}
                error={!!errors[name]}
                helperText={errors[name] ? errors[name] : ''}
                {...textFieldProps}
            />
        )}
    </Field>
);

export const FastFormikTextField: FunctionComponent<
    React.PropsWithChildren<FormikTextFieldProps>
> = ({ textFieldProps, name }) => (
    <Field name={name}>
        {({ field, form: { errors } }) => (
            <TextField
                {...field}
                error={!!errors[name]}
                helperText={errors[name] ? errors[name] : ''}
                {...textFieldProps}
            />
        )}
    </Field>
);
